import React from 'react';

// MuzzleEarBase — §4 耳朵细节 — 耳朵 C + A/B outer (ear-c/a/b-color)
// MUZZLE mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.

export function MuzzleEarBase({ config, parts }) {
  return (
    <>
<path className={"hood-" + config['ear-c-color'] + " str_222222_70"} d={parts['ear-c-color_c'] || ''}/>
<g id="_2100842927808">
<path className={"hood-" + config['ear-a-color'] + " str_222222_70"} d={parts['ear-a-color_c'] || ''}/>
<path className="clear str_222222_30_150_90" d={parts['clear-path-3'] || ''}/>
<path className="clear str_222222_30_150_90" d={parts['clear-path-4'] || ''}/>
</g>
<g id="_2100842924512">
<path className={"hood-" + config['ear-b-color'] + " str_222222_65"} d={parts['ear-b-color_c'] || ''}/>
<path className="clear str_222222_30_150_90" d={parts['clear-path-6'] || ''}/>
</g>
    </>
  );
}

// MuzzleEarInner — §4 耳朵细节 — 耳朵 A/B inner
// MUZZLE mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.

export function MuzzleEarInner({ config, parts }) {
  return (
    <>
<g id="_2100936161808">
<path className={"hood-" + config['ear-a-color'] + " str_222222_75"} d={parts['ear-a-color_c_2'] || ''}/>
<path className="clear str_222222_35_140_105" d={parts['clear-path-18'] || ''}/>
</g>
<g id="_2102033527296">
<path className={"hood-" + config['ear-b-color'] + " str_222222_70"} d={parts['ear-b-color_c_2'] || ''}/>
<path className="clear str_222222_35_140_105" d={parts['clear-path-20'] || ''}/>
<path className="clear str_222222_35_140_105" d={parts['clear-path-21'] || ''}/>
</g>
    </>
  );
}
